import { render, staticRenderFns } from "./InfographicStyleEditor.vue?vue&type=template&id=6ecd31b9&scoped=true&"
import script from "./InfographicStyleEditor.vue?vue&type=script&lang=js&"
export * from "./InfographicStyleEditor.vue?vue&type=script&lang=js&"
import style0 from "./InfographicStyleEditor.vue?vue&type=style&index=0&id=6ecd31b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecd31b9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TinyButton: require('/web/components/TinyButton.vue').default})
